import { render, staticRenderFns } from "./NewsDetailsMobile.vue?vue&type=template&id=d2bea142&scoped=true&"
import script from "./NewsDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./NewsDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailsMobile.vue?vue&type=style&index=0&id=d2bea142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bea142",
  null
  
)

export default component.exports